var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "url(#paint0_linear_9487_31563)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4152 19.6697H22.3671L22.2772 9.90219H22.277C22.2712 9.72699 22.1976 9.56106 22.0715 9.43922C21.9456 9.3174 21.7771 9.24942 21.6019 9.24942H9.96648C9.78563 9.24314 9.61012 9.31221 9.48217 9.44016C9.35407 9.56826 9.28499 9.74361 9.29143 9.92463L9.29143 22.8879C9.29143 23.5088 9.5379 24.1041 9.97701 24.5431C10.4159 24.982 11.0112 25.2286 11.632 25.2286H22.7948C23.4077 25.2169 23.9915 24.9651 24.4207 24.5274C24.8501 24.0897 25.0904 23.501 25.0903 22.888V20.3449C25.0903 20.1658 25.0192 19.9941 24.8926 19.8675C24.7659 19.7408 24.5942 19.6697 24.4152 19.6697L24.4152 19.6697ZM12.1496 12.8504H16.4707V14.2009L12.1496 14.2007V12.8504ZM12.1496 17.3066V15.9561H19.5539V17.3066H12.1496ZM23.74 22.888C23.74 23.1506 23.6356 23.4026 23.4499 23.5883C23.2642 23.774 23.0123 23.8783 22.7497 23.8783H14.6252C14.771 23.5684 14.8478 23.2305 14.8503 22.888L14.8503 21.02H23.74L23.74 22.888Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4152 19.6697H22.3671L22.2772 9.90219H22.277C22.2712 9.72699 22.1976 9.56106 22.0715 9.43922C21.9456 9.3174 21.7771 9.24942 21.6019 9.24942H9.96648C9.78563 9.24314 9.61012 9.31221 9.48217 9.44016C9.35407 9.56826 9.28499 9.74361 9.29143 9.92463L9.29143 22.8879C9.29143 23.5088 9.5379 24.1041 9.97701 24.5431C10.4159 24.982 11.0112 25.2286 11.632 25.2286H22.7948C23.4077 25.2169 23.9915 24.9651 24.4207 24.5274C24.8501 24.0897 25.0904 23.501 25.0903 22.888V20.3449C25.0903 20.1658 25.0192 19.9941 24.8926 19.8675C24.7659 19.7408 24.5942 19.6697 24.4152 19.6697L24.4152 19.6697ZM12.1496 12.8504H16.4707V14.2009L12.1496 14.2007V12.8504ZM12.1496 17.3066V15.9561H19.5539V17.3066H12.1496ZM23.74 22.888C23.74 23.1506 23.6356 23.4026 23.4499 23.5883C23.2642 23.774 23.0123 23.8783 22.7497 23.8783H14.6252C14.771 23.5684 14.8478 23.2305 14.8503 22.888L14.8503 21.02H23.74L23.74 22.888Z",
    fill: "url(#paint1_linear_9487_31563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9487_31563",
    x1: 3.88889,
    y1: 29.8148,
    x2: 35,
    y2: 11.8827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9487_31563",
    x1: 9.29102,
    y1: 23.6751,
    x2: 25.2033,
    y2: 12.9681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC369"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconNew);
export default __webpack_public_path__ + "static/media/SurveyIconNew.a2bf20ca4b45d5d6fddcd6fde72877f2.svg";
export { ForwardRef as ReactComponent };